module.exports = __webpack_public_path__ + "img/original.b50f7c48.png";